export function getTenantName() {
    const hostname = window.location.hostname;
    // Remove protocol (http:// or https://) if present
    const cleanOrigin = hostname.replace(/^(https?:\/\/)/, "");
    const parts = cleanOrigin.split(".");
    let tenant;
    if (parts.length >= 2) {
        tenant = parts[0];
    } else {
        tenant = process.env.REACT_APP_LOCAL_TENANT || "trexo-dev"; // Fallback to a default tenant if not found
    }
    return tenant;
}

export function isCrowellTenant() {
    const generatorTenant = process.env.REACT_APP_NUMBER_GENERATOR_TENANT;
    if (!generatorTenant) return false;
    let isCrowellTenantBool = generatorTenant.toLowerCase() === getTenantName().toLowerCase();
    return isCrowellTenantBool;
}